export default __webpack_public_path__ + "static/media/mixveg.29b1b346.jpg";